import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '@app/core/services/base-http.service';

import { ReservationValueDetailsModel } from './reservation-values.model';

@Injectable({
  providedIn: 'root'
})
export class ReservationValuesService extends BaseHttpService {
  getDetailedList(reservationNumber: string): Observable<ReservationValueDetailsModel[]> {
    return this.httpClient.get<ReservationValueDetailsModel[]>(
      `${this.baseApiUrl}/api/reservationValueItem/detailedList?reservationNumber=${reservationNumber}`
    );
  }
}
